/*** IMPORTS FROM imports-loader ***/
var define = false;

require('./_wks-define')('asyncIterator');

